// extracted by mini-css-extract-plugin
export var mainRoot = "Main-module--main-root--8jy+l";